import { render } from "./NomenclatureTypes.vue?vue&type=template&id=1dab6862&scoped=true"
import script from "./NomenclatureTypes.vue?vue&type=script&lang=js"
export * from "./NomenclatureTypes.vue?vue&type=script&lang=js"

import "./NomenclatureTypes.vue?vue&type=style&index=0&id=1dab6862&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dab6862"]])

export default __exports__